module.exports = __webpack_public_path__ + "img/1.897807a3.jpg";